const config = document.querySelector('script[data-zoq-cro]');
if (config && config.dataset.enabled === 'true' && !window.Shopify?.designMode) {
  const sent = new Set();
  const controller = new AbortController();
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const publish = (name, data = {}, once = false) => {
    if (!allowed() || (once && sent.has(name))) return;
    sent.add(name);
    const payload = { homepage_version: 'cro_2026_10', ...data };
    try {
      Promise.resolve(window.Shopify?.analytics?.publish?.(`zoq:${name}`, payload)).catch(() => {});
      if (typeof window.gtag === 'function' && config.dataset.ga4Id) {
        window.gtag('event', `zoq_${name}`, { ...payload, send_to: config.dataset.ga4Id });
      }
    } catch {}
  };
  const view = () => publish('homepage_view', {}, true);
  const observers = new Set();
  const observe = () => {
    for (const observer of observers) observer.disconnect();
    observers.clear();
    view();
    for (const [selector, name] of [['[id$="__slideshow_zq"]', 'hero_view'], ['[data-zoq-reviews]', 'reviews_view']]) {
      const element = document.querySelector(selector);
      if (!element || sent.has(name)) continue;
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting) && allowed()) {
          publish(name, {}, true);
          observer.disconnect();
          observers.delete(observer);
        }
      }, { threshold: 0.5 });
      observer.observe(element);
      observers.add(observer);
    }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a');
    if (!link) return;
    const target = new URL(link.href, window.location.origin);
    if (target.origin !== window.location.origin) return;
    const data = { destination: target.pathname };
    if (link.closest('[id$="__slideshow_zq"]')) publish('hero_click', data);
    else if (link.closest('[id$="__categories"]')) publish('category_click', data);
    else if (link.matches('[data-zoq-review-product]')) publish('review_product_click', data);
  }, { signal: controller.signal });
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add') return;
    Promise.resolve(event.promise).then(() => publish('homepage_add_to_cart')).catch(() => {});
  }, { capture: true, signal: controller.signal });
  document.addEventListener('visitorConsentCollected', () => {
    for (const observer of observers) observer.disconnect();
    observers.clear();
    observe();
  }, { signal: controller.signal });
  window.addEventListener('pagehide', (event) => {
    for (const observer of observers) observer.disconnect();
    observers.clear();
    if (!event.persisted) controller.abort();
  }, { signal: controller.signal });
  window.addEventListener('pageshow', observe, { signal: controller.signal });
  observe();
}
